<script setup>
import { useSlider } from '@/composeables/useSlider';
import { ref } from 'vue';

const props = defineProps({})

const items = ref([0,1,2,3]);

const { activeIndex, slidePrev, slideNext, slideTo, current, direction, canNext, canPrev } = useSlider(items);

</script>

<template>
    <slot v-bind="{
        current,
        activeIndex,
        slidePrev,
        slideNext,
        slideTo,
        current,
        direction,
        canNext,
        canPrev,
    }" />
</template>

<style lang="scss">
// @use "@/scss/framework" as *;

// @layer components.media-gallery {
//     .media-gallery {}
// }
</style>
